import { useContext, useEffect, useCallback } from "react";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { CstmTextField } from "../../../../../core/global/forms/CstmTextField";
import { Box, Autocomplete, Button } from "@mui/material";
import moment from "moment";
import { BranchUserRead } from "../../../global/API";
import { Sync as SyncIcon } from "@mui/icons-material";
import { CstmSnackBar } from "../../../../../core/global/forms/CstmSnackBar";

export const Generate = ({ handleGenerate }) => {
    const today = moment().format("YYYY-MM-DD");
    const { reconciliation_state, tool_state, setup_state } = useContext(ToolContext);
    const { snackBarLoader, form, infiniteState } = reconciliation_state;
    const { __SESSION } = tool_state;
    const { branchUserData } = setup_state;
    let user_id = parseInt(atob(__SESSION.data.ainfo.aid).split('_', 2)[1]);
    const tool_id = process.env.REACT_APP_TID_BIZ;
    const role = __SESSION.data.uaccess[0].role_name

    const inputChangeHandler = async(e, val, key) => {
        let name
        let value
        if (key === 'branch_id') {
            name = key;
            value = (val === null ? 0 : val.company_branch_id);
        } else {
            name = e.target.name
            value = e.target.value
        }
        form.set({...form.data, [name]:value})
        infiniteState.set((prev) => ({...prev, infiniteLoad:false, offset:0}))
    }

    const __init = useCallback(async () => {
        let qsp = {
            user_id: user_id,
            company_id: __SESSION.data.uaccess[0].company_id,
            filter: 'active',
            tool_id: tool_id,
        };
        let res = await BranchUserRead(qsp);

        if (res) {
            res.length > 0 && branchUserData.set([{id:0, company_branch_id: 0, name:'All', code:'000', active:1}, ...res])
        }
    }, [user_id, __SESSION.data.uaccess, tool_id, branchUserData]);

    useEffect(() => {
        __init();
        if (!form.data?.from || !form.data?.to) {
            form.set(prev => ({ ...prev, from: today, to: today }));
        }
        //eslint-disable-next-line
    }, []);

    return (
        <>
            <Box width="100%" display="flex" alignItems="center" gap={3} bgcolor="#FFFFFF" borderRadius="12px" p={2}>
                <Autocomplete
                    fullWidth
                    options={branchUserData.data || []}
                    getOptionLabel={(option) => option.name}
                    onChange={(e, value) => inputChangeHandler(e, value, 'branch_id')}
                    value={
                        form.data.branch_id === '' || form.data.branch_id === undefined 
                            ? null 
                            : branchUserData.data?.find((f) => f.company_branch_id === form.data.branch_id) || null
                    } 
                    renderInput={(params) => (
                        <CstmTextField {...params} label="Branch" placeholder="Branch" />
                    )}
                />
                <CstmTextField fullWidth type="date" variant="outlined" label="Date From" name="from" InputLabelProps={{shrink: true}} InputProps={{ inputProps: { max: today}}} onInput={(e) => inputChangeHandler(e)} value={form.data.from || ''} error={snackBarLoader.data && form.data.from === ''}/>
                {role !== "Regular User" && <CstmTextField fullWidth type="date" variant="outlined" label="Date To" name="to" InputLabelProps={{shrink: true}} InputProps={{inputProps: {min: form.data.from, max:"9999-12-31"}}} onInput={(e) => inputChangeHandler(e)} value={form.data.to || ''} error={((snackBarLoader.data && form.data.to === '') || (form.data.to < form.data.from))}/>}
                <Box onClick={handleGenerate} component={Button} disableFocusRipple={true} minHeight="50px" minWidth="130px" borderRadius={3} display="flex" alignItems="center" justifyContent="center" bgcolor="primary.main" color="#fff" sx={{border:"2px solid #EBEBEB", ':hover':{bgcolor:'primary.main', color:'#FFFFFF'}}} startIcon={<SyncIcon/>}>
                    <Box fontSize={16} fontWeight={400} lineHeight="19px">Generate</Box>
                </Box>
            </Box>
            {snackBarLoader.data.snackbar && (
                <CstmSnackBar value={snackBarLoader.data} setter={snackBarLoader.set} msg={snackBarLoader.data.msg} type='error' /> 
            )}
        </>
    );
};